export const lastnames = [
    { name: "Martin", poids: 250013 },
    { name: "Bernard", poids: 131330 },
    { name: "Thomas", poids: 118331 },
    { name: "Petit", poids: 115217 },
    { name: "Robert", poids: 112998 },
    { name: "Richard", poids: 109354 },
    { name: "Dubois", poids: 108619 },
    { name: "Durand", poids: 108374 },
    { name: "Moreau", poids: 102804 },
    { name: "Laurent", poids: 97015 },
    { name: "Simon", poids: 96397 },
    { name: "Michel", poids: 93493 },
    { name: "Lefebvre", poids: 91459 },
    { name: "Leroy", poids: 87282 },
    { name: "David", poids: 76085 },
    { name: "Roux", poids: 75365 },
    { name: "Morel", poids: 72745 },
    { name: "Bertrand", poids: 72683 },
    { name: "Fournier", poids: 71996 },
    { name: "Girard", poids: 70039 },
    { name: "Fontaine", poids: 70000 },
    { name: "Lambert", poids: 69252 },
    { name: "Dupont", poids: 69221 },
    { name: "Bonnet", poids: 68481 },
    { name: "Rousseau", poids: 68010 },
    { name: "Vincent", poids: 66396 },
    { name: "Muller", poids: 64309 },
    { name: "Lefevre", poids: 64107 },
    { name: "Faure", poids: 62937 },
    { name: "Andre", poids: 62715 },
    { name: "Mercier", poids: 62601 },
    { name: "Guerin", poids: 62183 },
    { name: "Garcia", poids: 61938 },
    { name: "Boyer", poids: 61922 },
    { name: "Blanc", poids: 61743 },
    { name: "Garnier", poids: 61499 },
    { name: "Chevalier", poids: 59902 },
    { name: "Francois", poids: 59714 },
    { name: "Legrand", poids: 59162 },
    { name: "Gauthier", poids: 571731 },
    { name: "Perrin", poids: 56419 },
    { name: "Robin", poids: 55816 },
    { name: "Clement", poids: 55223 },
    { name: "Morin", poids: 54669 },
    { name: "Henry", poids: 53949 },
    { name: "Nicolas", poids: 53537 },
    { name: "Roussel", poids: 53520 },
    { name: "Gautier", poids: 53164 },
    { name: "Mathieu", poids: 53090 },
    { name: "Masson", poids: 52584 },
    { name: "Duval", poids: 51131 },
    { name: "Marchand", poids: 50838 },
    { name: "Denis", poids: 49289 },
    { name: "Lemaire", poids: 48873 },
    { name: "Dumont", poids: 48757 },
    { name: "Marie", poids: 48635 },
    { name: "Noel", poids: 48601 },
    { name: "Meyer", poids: 47492 },
    { name: "Dufour", poids: 47439 },
    { name: "Meunier", poids: 47200 },
    { name: "Martinez", poids: 47023 },
    { name: "Blanchard", poids: 46004 },
    { name: "Brun", poids: 45695 },
    { name: "Riviere", poids: 45694 },
    { name: "Lucas", poids: 45444 },
    { name: "Joly", poids: 45336 },
    { name: "Giraud", poids: 45026 },
    { name: "Brunet", poids: 44638 },
    { name: "Gaillard", poids: 44341 },
    { name: "Barbier", poids: 44176 },
    { name: "Gerard", poids: 43649 },
    { name: "Arnaud", poids: 43537 },
    { name: "Renard", poids: 42672 },
    { name: "Roche", poids: 42580 },
    { name: "Schmitt", poids: 42249 },
    { name: "Roy", poids: 41749 },
    { name: "Leroux", poids: 41589 },
    { name: "Caron", poids: 41553 },
    { name: "Colin", poids: 41318 },
    { name: "Vidal", poids: 41003 },
    { name: "Picard", poids: 41000 },
    { name: "Roger", poids: 40599 },
    { name: "Fabre", poids: 39997 },
    { name: "Aubert", poids: 39336 },
    { name: "Lemoine", poids: 39158 },
    { name: "Renaud", poids: 38063 },
    { name: "Dumas", poids: 37562 },
    { name: "Payet", poids: 37410 },
    { name: "Olivier", poids: 37366 },
    { name: "Lacroix", poids: 37290 },
    { name: "Philippe", poids: 36722 },
    { name: "Pierre", poids: 36669 },
    { name: "Bourgeois", poids: 36647 },
    { name: "Lopez", poids: 36571 },
    { name: "Benoit", poids: 35997 },
    { name: "Leclerc", poids: 35952 },
    { name: "Rey", poids: 35603 },
    { name: "Leclercq", poids: 35282 },
    { name: "Sanchez", poids: 35260 },
    { name: "Lecomte", poids: 35165 },
    { name: "Rolland", poids: 34991 },
    { name: "Guillaume", poids: 34946 },
    { name: "Jean", poids: 33993 },
    { name: "Hubert", poids: 33532 },
    { name: "Dupuy", poids: 33468 },
    { name: "Carpentier", poids: 33267 },
    { name: "Guillot", poids: 33243 },
    { name: "Berger", poids: 33162 },
    { name: "Perez", poids: 33087 },
    { name: "Dupuis", poids: 32749 },
    { name: "Louis", poids: 32513 },
    { name: "Moulin", poids: 32232 },
    { name: "Deschamps", poids: 31482 },
    { name: "Vasseur", poids: 31409 },
    { name: "Huet", poids: 31363 },
    { name: "Boucher", poids: 30532 },
    { name: "Fernandez", poids: 30435 },
    { name: "Fleury", poids: 30347 },
    { name: "Adam", poids: 30156 },
    { name: "Royer", poids: 30117 },
    { name: "Paris", poids: 30053 },
    { name: "Jacquet", poids: 29997 },
    { name: "Klein", poids: 29805 },
    { name: "Poirier", poids: 29757 },
    { name: "Charles", poids: 29664 },
    { name: "Aubry", poids: 29659 },
    { name: "Guyot", poids: 29550 },
    { name: "Carre", poids: 29318 },
    { name: "Renault", poids: 29269 },
    { name: "Menard", poids: 29208 },
    { name: "Maillard", poids: 29190 },
    { name: "Charpentier", poids: 29185 },
    { name: "Marty", poids: 29153 },
    { name: "Bertin", poids: 29118 },
    { name: "Baron", poids: 29038 },
    { name: "Da Silva", poids: 28730 },
    { name: "Bailly", poids: 28461 },
    { name: "Herve", poids: 28139 },
    { name: "Schneider", poids: 28400 },
    { name: "Le Gall", poids: 27857 },
    { name: "Collet", poids: 27784 },
    { name: "Leger", poids: 27715 },
    { name: "Bouvier", poids: 27490 },
    { name: "Julien", poids: 27182 },
    { name: "Prevost", poids: 27099 },
    { name: "Millet", poids: 26788 },
    { name: "Le Roux", poids: 26173 },
    { name: "Daniel", poids: 26571 },
    { name: "Perrot", poids: 26530 },
    { name: "Cousin", poids: 26515 },
    { name: "Germain", poids: 26343 },
    { name: "Breton", poids: 26055 },
    { name: "Rodriguez", poids: 26021 },
    { name: "Langlois", poids: 25998 },
    { name: "Remy", poids: 25844 },
    { name: "Besson", poids: 25717 },
    { name: "Leveque", poids: 25621 },
    { name: "Le Goff", poids: 25569 },
    { name: "Pelletier", poids: 25569 },
    { name: "Leblanc", poids: 25423 },
    { name: "Barre", poids: 25242 },
    { name: "Lebrun", poids: 25189 },
    { name: "Grondin", poids: 25104 },
    { name: "Perrier", poids: 25082 },
    { name: "Marchal", poids: 24935 },
    { name: "Weber", poids: 24758 },
    { name: "Boulanger", poids: 24602 },
    { name: "Mallet", poids: 24524 },
    { name: "Hamon", poids: 24506 },
    { name: "Jacob", poids: 24433 },
    { name: "Monnier", poids: 24398 },
    { name: "Michaud", poids: 24146 },
    { name: "Guichard", poids: 24145 },
    { name: "Poulain", poids: 23983 },
    { name: "Etienne", poids: 23970 },
    { name: "Gillet", poids: 23930 },
    { name: "Hoarau", poids: 23868 },
    { name: "Tessier", poids: 23702 },
    { name: "Chevallier", poids: 23548 },
    { name: "Collin", poids: 23446 },
    { name: "Lemaitre", poids: 23418 },
    { name: "Benard", poids: 23390 },
    { name: "Chauvin", poids: 23349 },
    { name: "Bouchet", poids: 23110 },
    { name: "Marechal", poids: 23061 },
    { name: "Gay", poids: 23032 },
    { name: "Humbert", poids: 22598 },
    { name: "Gonzalez", poids: 22554 },
    { name: "Antoine", poids: 22553 },
    { name: "Perret", poids: 22282 },
    { name: "Reynaud", poids: 22281 },
    { name: "Cordier", poids: 21856 },
    { name: "Lejeune", poids: 21731 },
    { name: "Barthelemy", poids: 21693 },
    { name: "Delaunay", poids: 21691 },
    { name: "Carlier", poids: 21636 },
    { name: "Pichon", poids: 21608 },
    { name: "Pasquier", poids: 21537 },
    { name: "Lamy", poids: 21483 },
    { name: "Gilbert", poids: 21442 }
];

export const firstnameMen = [
    {name: 'Jean', poids: 1913420},
    {name: 'Pierre', poids: 891947},
    {name: 'Michel', poids: 820429},
    {name: 'André', poids: 712048},
    {name: 'Philippe', poids: 538593},
    {name: 'Louis', poids: 528949},
    {name: 'René', poids: 516233},
    {name: 'Alain', poids: 506937},
    {name: 'Jacques', poids: 482928},
    {name: 'Bernard', poids: 469266},
    {name: 'Marcel', poids: 469085},
    {name: 'Daniel', poids: 436268},
    {name: 'Paul', poids: 423779},
    {name: 'Roger', poids: 423599},
    {name: 'Robert', poids: 419159},
    {name: 'Claude', poids: 411753},
    {name: 'Henri', poids: 405972},
    {name: 'Christian', poids: 405623},
    {name: 'Nicolas', poids: 405418},
    {name: 'Georges', poids: 405098},
    {name: 'François', poids: 398614},
    {name: 'Patrick', poids: 395141},
    {name: 'Gérard', poids: 379393},
    {name: 'Joseph', poids: 377429},
    {name: 'Christophe', poids: 375963},
    {name: 'Julien', poids: 344795},
    {name: 'Maurice', poids: 337129},
    {name: 'Laurent', poids: 328514},
    {name: 'Frédéric', poids: 327875},
    {name: 'Eric', poids: 318274},
    {name: 'David', poids: 314449},
    {name: 'Stéphane', poids: 308499},
    {name: 'Pascal', poids: 307824},
    {name: 'Sébastien', poids: 304015},
    {name: 'Alexandre', poids: 303145},
    {name: 'Thierry', poids: 289566},
    {name: 'Antoine', poids: 280865},
    {name: 'Olivier', poids: 280164},
    {name: 'Thomas', poids: 280161},
    {name: 'Raymond', poids: 272819},
    {name: 'Guy', poids: 265718},
    {name: 'Charles', poids: 242335},
    {name: 'Dominique', poids: 241958},
    {name: 'Marc', poids: 237778},
    {name: 'Didier', poids: 237166},
    {name: 'Vincent', poids: 232436},
    {name: 'Bruno', poids: 230315},
    {name: 'Jean-Marc', poids: 229398},
    {name: 'Simon', poids: 227698},
    {name: 'Luc', poids: 224768},
    {name: 'Emmanuel', poids: 223497}
];

export const firstnameWomen = [
    {name: 'Marie', poids: 2260239},
    {name: 'Jeanne', poids: 481783},
    {name: 'Martine', poids: 394692},
    {name: 'Nathalie', poids: 382958},
    {name: 'Isabelle', poids: 378144},
    {name: 'Jacqueline', poids: 372507},
    {name: 'Sylvie', poids: 364652},
    {name: 'Anne', poids: 364331},
    {name: 'Martine', poids: 320189},
    {name: 'Madeleine', poids: 305378},
    {name: 'Nicole', poids: 293581},
    {name: 'Suzanne', poids: 290385},
    {name: 'Hélène', poids: 281304},
    {name: 'Christine', poids: 280638},
    {name: 'Louise', poids: 275161},
    {name: 'Marguerite', poids: 271187},
    {name: 'Denise', poids: 263367},
    {name: 'Christiane', poids: 259526},
    {name: 'Yvonne', poids: 256941},
    {name: 'Valérie', poids: 253067},
    {name: 'Sophie', poids: 246234},
    {name: 'Sandrine', poids: 240238},
    {name: 'Céline', poids: 238799},
    {name: 'Stéphanie', poids: 238678},
    {name: 'Véronique', poids: 235730},
    {name: 'Chantal', poids: 232199},
    {name: 'Marcelle', poids: 229302},
    {name: 'Renée', poids: 221729},
    {name: 'Simone', poids: 219948},
    {name: 'Jeannine', poids: 218738},
    {name: 'Andrée', poids: 215438},
    {name: 'Julie', poids: 214757},
    {name: 'Paulette', poids: 213333},
    {name: 'Germaine', poids: 210978},
    {name: 'Annie', poids: 210168},
    {name: 'Lucie', poids: 207683},
    {name: 'Patricia', poids: 207498},
    {name: 'Camille', poids: 206640},
    {name: 'Léa', poids: 204202},
    {name: 'Yvette', poids: 203445},
    {name: 'Brigitte', poids: 202584},
    {name: 'Alice', poids: 201589},
    {name: 'Emilie', poids: 193194},
    {name: 'Odette', poids: 192569},
    {name: 'Geneviève', poids: 185953},
    {name: 'Aurélie', poids: 182485},
    {name: 'Laurence', poids: 181703},
    {name: 'Michèle', poids: 179961},
    {name: 'Monique', poids: 179530},
    {name: 'Cathy', poids: 178687}
];

export const raisons = [
    { name: "que mon enfant pense que je suis le meilleur parent au monde pour son anniversaire.", poids: 10 },
    { name: "impressionner mon patron et mes collègues lors de la soirée d'entreprise et décrocher une promotion.", poids: 9 },
    { name: "ajouter un peu de magie à mon mariage pour que mes beaux-parents m'aiment enfin.", poids: 8 },
    { name: "faire croire à ma famille que je connais un véritable magicien lors de notre prochaine réunion.", poids: 7 },
    { name: "transformer la kermesse de l'école en un événement légendaire dont on parlera pendant des années.", poids: 6 },
    { name: "faire disparaître mon meilleur ami lors de son enterrement de vie de garçon... juste pour rire.", poids: 5 },
    { name: "surprendre la future mariée avec des tours de magie qui feront oublier le strip-teaseur annulé.", poids: 5 },
    { name: "faire croire à tout le monde que notre nouveau produit est littéralement magique.", poids: 4 },
    { name: "rendre la fête de quartier tellement cool que même les voisins grincheux ne pourront pas râler.", poids: 3 },
    { name: "organiser un spectacle caritatif pour prouver que même les magiciens ont un cœur d'or.", poids: 2 }
];

/** Definitions d'un objet d'état des différents éléments du DOM */
export let statements = {
    animation_running : true,
    section_active : false,
}

export let ids = {
    letterK     : '#letterK',
    letterR     : '#letterR',
    letterI     : '#letterI',
    letterS     : '#letterS',
    letterS2    : '#letterS2',

    taglineTop      : '#taglineTop',
    taglineBottom   : '#taglineBottom',
}

export let timelines = {}

